export default __webpack_public_path__ + "static/media/jeff-calendar.09605912.svg";